import { IAppState } from '../../../common/state';
import { IRegionalDistrict } from '../../../types/regionalDistricts';

export const selectRegionalDistrictById = (districtId: number) => (state: IAppState) => {
  const { districts } = state.filters.regionalDistrictsModal;

  return districts.find(({ id }) => id === districtId) as IRegionalDistrict;
};
